import script from "./EIAPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EIAPage.vue?vue&type=script&setup=true&lang=js"

import "./EIAPage.vue?vue&type=style&index=0&id=0071b826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0071b826"]])

export default __exports__